module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "lightgrey_bg",
    attrs: {
      "id": "testimonials"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.title != null) ? _c('div', {
    staticClass: "main_title mt_wave a_left"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title[_vm.currentLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.header != null) ? _c('p', {
    staticClass: "main_description"
  }, [_vm._v("\n                    " + _vm._s(_vm.header[_vm.currentLanguage]) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.testimonials.length > 0) ? _c('slider', {
    staticClass: "Testimonials",
    staticStyle: {
      "z-index": "0"
    },
    attrs: {
      "animation": "fade"
    }
  }, _vm._l((_vm.testimonials), function(testimonial) {
    return _c('slider-item', {
      key: testimonial.id
    }, [_c('testimonial', {
      attrs: {
        "testimonial": testimonial
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.testimonials.length == 0) ? _c('div', [_vm._m(0)]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center testimonials-empty"
  }, [_c('i', {
    staticClass: "fa fa-comment-o"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c7945f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/testimonials/Testimonials.vue
// module id = 370
// module chunks = 0